
  import {Vue} from "vue-property-decorator";
  import Component from "vue-class-component";
  import { DateTime } from "luxon";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  import router from "../../router";
  
  @Component({
    name: "InicioView",
  })
  export default class InicioView extends Vue {
    
    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
    private tab:any = null;
    public swEditar = false;
    public cita_selected = null
    datos2 = [];
    fecha = DateTime.now().toFormat('yyyy-MM-dd');
    
    public fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
    public fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");

		get reservas(): any {
			return this.consultorioStore.reservas;
		}
    mounted(){
      this.consultorioService.getReservas({ fechaInicial: this.fechaInicial, fechaFinal: this.fechaFinal });
			this.consultorioService.getDataHome();
    }
    
    nuevo(){
      router.push({name: 'nueva-cita'});
    }
    
    verPacientes(){
      router.push({name: 'pacientes'});
    }
    
    get pagination(): any {
      return this.consultorioStore.pagination;
    }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }
    get dataHome(): any {
			return this.consultorioStore.dataHome;
		}
  }
